module.exports = __webpack_public_path__ + "img/form-locked.9c83418d.png";